module.exports = __webpack_public_path__ + "static/img/thumbnail.38bc76b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/articles/191029/thumbnail.png
// module id = VW3M
// module chunks = 1